import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {

  subscribers: Subscriber<void>[] = [];

  constructor() {
  }

  toggle(): void {
    this.subscribers.forEach(s => s.next());
  }

  toggleEvents(): Observable<void> {
    return new Observable<void>(subscriber => {
      this.subscribers.push(subscriber);
      return {
        unsubscribe(): void {
        }
      };
    });
  }
}
